module.exports = __webpack_public_path__ + "img/_2.2aa79549.png";